import React from 'react';
import { Wind, Settings, Wrench, FileCheck, Building2, Thermometer } from 'lucide-react';

export const Services = () => {
  const services = [
    {
      icon: Wind,
      title: 'Projetos de Climatização',
      description: 'Desenvolvimento de projetos técnicos personalizados para ambientes comerciais e industriais, considerando as necessidades específicas de cada espaço.',
    },
    {
      icon: Building2,
      title: 'Execução de Obras',
      description: 'Realização completa de obras de climatização, desde a infraestrutura até a instalação final dos equipamentos, com acompanhamento técnico.',
    },
    {
      icon: Settings,
      title: 'Instalação de Sistemas',
      description: 'Instalação profissional de sistemas de ar condicionado split, multi-split, VRF e centrais de água gelada para diversos tipos de ambientes.',
    },
    {
      icon: Wrench,
      title: 'Manutenção Preventiva',
      description: 'Serviços periódicos de manutenção para garantir o funcionamento eficiente dos equipamentos e prolongar sua vida útil.',
    },
    {
      icon: Thermometer,
      title: 'Manutenção Corretiva',
      description: 'Diagnóstico e reparo de problemas em sistemas de climatização, com atendimento técnico especializado e ágil.',
    },
    {
      icon: FileCheck,
      title: 'Contratos PMOC',
      description: 'Elaboração e execução de Plano de Manutenção, Operação e Controle conforme legislação vigente, garantindo conformidade e qualidade do ar.',
    },
  ];

  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="py-20 lg:py-32 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-testid="services-header">
          <span className="font-manrope text-sm font-bold tracking-[0.2em] uppercase text-sky-600">
            Nossos Serviços
          </span>
          <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900 mt-4 mb-6">
            Soluções completas para sua empresa
          </h2>
          <div className="section-divider mx-auto mb-6"></div>
          <p className="font-manrope text-base sm:text-lg text-slate-600 leading-relaxed">
            Oferecemos uma gama completa de serviços em climatização, desde o projeto 
            inicial até a manutenção contínua dos sistemas.
          </p>
        </div>

        {/* Services Grid */}
        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
          data-testid="services-grid"
        >
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card bg-white rounded-2xl border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] transition-all duration-300 p-6 lg:p-8 card-hover"
              data-testid={`service-card-${index}`}
            >
              {/* Icon */}
              <div className="service-icon w-14 h-14 bg-sky-50 rounded-xl flex items-center justify-center mb-6 transition-all duration-300">
                <service.icon className="w-7 h-7 text-sky-600" strokeWidth={1.5} />
              </div>

              {/* Title */}
              <h3 className="font-outfit text-xl font-semibold text-slate-800 mb-3">
                {service.title}
              </h3>

              {/* Description */}
              <p className="font-manrope text-sm text-slate-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
